import React from 'react'

import { authorization } from 'Module/Auth/Auth'

import UIBlocker from './UIBlocker'
import CityDetails from './CityDetails'
import {
  getDefaultBaCitySettingsData,
  getDefaultCityData,
  getDefaultSpyData,
} from './utils'
import SpyDetails from './SpyDetails'
import BaDetails from './BaDetails'
import SpyReportOptions from './SpyReportOptions'

const CommonView = props => {
  const {
    cityData,
    isLoaded,
    isEdit = false,
    isCreate = false,
    countries,
    enableEditCountry,
    enableChangeTimezone,
    isSaving,
    updateCitySpySettings,
    updateCity,
    updateBaCitySettings,
  } = props
  const isAdmin = authorization.isAdmin()

  if (!isLoaded) return 'Loading...'

  const defaultCityDetailsValues = getDefaultCityData({
    cityData,
    props,
    isAdmin,
  })

  const defaultSpyValues = getDefaultSpyData({ cityData })

  const defaultBaCitySettingsValues = getDefaultBaCitySettingsData({ cityData })

  return (
    <div>
      <CityDetails
        defaultValues={defaultCityDetailsValues}
        updateCity={updateCity}
        isEdit={isEdit}
        isCreate={isCreate}
        countries={countries}
        country={cityData ? cityData.country : null}
        isAdmin={isAdmin}
        enableChangeTimezone={enableChangeTimezone}
        enableEditCountry={enableEditCountry}
      />

      {isEdit && (
        <BaDetails
          defaultValues={defaultBaCitySettingsValues}
          updateBaCitySettings={updateBaCitySettings}
          isEdit={isEdit}
          isCreate={isCreate}
          cityData={cityData}
        />
      )}

      <SpyDetails
        defaultValues={defaultSpyValues}
        updateCitySpySettings={updateCitySpySettings}
        isSaving={isSaving}
        isEdit={isEdit}
      />

      {isEdit && cityData && cityData.id ? (
        <SpyReportOptions cityId={cityData.id} />
      ) : null}

      {isSaving ? <UIBlocker>Loading...</UIBlocker> : null}
    </div>
  )
}

export default CommonView
